import React from 'react'
import { ComponenteBaseEnlace, ImagenEnlace, PrecioEnlace } from './ComponenteBase'

const DiseñoClassic = ({ 
  enlaces = [], 
  estilosMiniatura = false, 
  esPreview = false,
  configuracion = {}
}) => {
  // Configuración por defecto para el diseño Classic
  const config = {
    estilo: 'tradicional', // tradicional | elegante | corporate
    mostrarNumeros: true, // true | false
    ...configuracion
  }

  // Ajustar para estilos miniatura
  if (estilosMiniatura) {
    return (
      <div className="space-y-1">
        {enlaces.map((enlace, index) => (
          <ComponenteBaseEnlace
            key={enlace.id || index}
            enlace={enlace}
            estilosMiniatura={estilosMiniatura}
            esPreview={esPreview}
            className="enlace-miniatura"
          >
            <div className="bg-white border border-gray-300 p-2 mb-1 hover:border-gray-400 transition-all duration-200">
              <div className="space-y-1">
                {/* Título arriba */}
                <div className="flex items-center gap-1">
                  {config.mostrarNumeros && (
                    <span className="text-xs text-gray-500 font-serif">{index + 1}.</span>
                  )}
                  <h3 className="font-serif text-gray-800 hover:text-blue-800 transition-colors text-xs leading-tight truncate flex-1">
                    {enlace.titulo}
                  </h3>
                </div>
                
                {/* Imagen y precio */}
                <div className="flex items-start gap-2">
                  <div className="flex-shrink-0">
                    <ImagenEnlace 
                      enlace={enlace} 
                      estilosMiniatura={estilosMiniatura}
                      mostrarIcono={false}
                    />
                  </div>
                  <div className="flex-1 flex flex-col gap-1">
                    {/* Precio para productos */}
                    {enlace.tipo === 'producto' && (
                      <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                    )}
                  </div>
                </div>
                
                {/* Descripción abajo */}
                {enlace.descripcion && (
                  <p className="text-gray-600 text-xs font-serif leading-tight">
                    {enlace.descripcion}
                  </p>
                )}
                
                {/* Precio para enlaces que no son productos */}
                {enlace.tipo !== 'producto' && (
                  <div>
                    <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                  </div>
                )}
              </div>
            </div>
          </ComponenteBaseEnlace>
        ))}
      </div>
    )
  }

  // Diseño normal para desktop
  return (
    <div className="space-y-3">
      {enlaces.map((enlace, index) => (
        <ComponenteBaseEnlace
          key={enlace.id || index}
          enlace={enlace}
          estilosMiniatura={estilosMiniatura}
          esPreview={esPreview}
          className="group"
        >
          <div className="bg-white border border-gray-300 p-5 hover:border-gray-400 hover:shadow-md transition-all duration-200">
            <div className="space-y-3">
              {/* Título arriba */}
              <div className="flex items-center gap-2">
                {config.mostrarNumeros && (
                  <span className="text-lg text-gray-500 font-serif">{index + 1}.</span>
                )}
                <h3 className="font-serif text-gray-800 group-hover:text-blue-800 transition-colors text-lg font-semibold flex-1">
                  {enlace.titulo}
                </h3>
              </div>
              
              {/* Imagen y precio */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <ImagenEnlace 
                    enlace={enlace} 
                    estilosMiniatura={estilosMiniatura}
                    mostrarIcono={false}
                  />
                </div>
                <div className="flex-1 flex flex-col gap-2">
                  {/* Precio para productos */}
                  {enlace.tipo === 'producto' && (
                    <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                  )}
                </div>
              </div>
              
              {/* Descripción abajo */}
              {enlace.descripcion && (
                <p className="text-gray-600 text-sm font-serif">
                  {enlace.descripcion}
                </p>
              )}
              
              {/* Precio para enlaces que no son productos */}
              {enlace.tipo !== 'producto' && (
                <div>
                  <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                </div>
              )}
            </div>
          </div>
        </ComponenteBaseEnlace>
      ))}
    </div>
  )
}

export default DiseñoClassic 